export default __webpack_public_path__ + "static/media/02.20.25 Minutes Reg Mtg.4e4a149f.pdf";